<template>
  <div class="bespread-wrap module-layer4">
    <div class="screen-container">
      <img
        src="../../assets/img/layer4/cha2.png"
        alt=""
        srcset=""
        class="cha-r-b"
      />
      <div class="kv-content">
        <img
          src="../../assets/img/layer4/title.png"
          alt=""
          srcset=""
          class="title"
        />
        <div class="btn-list">
          <img
            v-for="(b, idx) in btnList"
            :key="idx"
            :src="btnIdx == b.id ? b.btnActive : b.btn"
            alt=""
            srcset=""
            class="btn-size"
            @click="handleBtn(b)"
          />
        </div>
        <!-- 不同 的btn下，显示的东西不一样 -->

        <div class="btn-gallery" v-if="btnIdx == 1">
          <swiper :options="galleryOptions" ref="galleryOptions">
            <swiper-slide v-for="(g, idx) in galleryList" :key="idx">
              <div class="g-banner">
                <div class="g-item-bg-i">
                  <img :src="g.url" class="d-info" />
                </div>
                <!-- <div
                  class="g-item-bg"
                  v-for="(gList, gIdx) in g.list"
                  :key="gIdx"
                >
                  <img :src="gList" class="info" />
                </div> -->
              </div>
            </swiper-slide>
          </swiper>
          <div class="swiper-button-prev-gallery"></div>
          <div class="swiper-button-next-gallery"></div>
          <div
            class="swiper-pagination swiper-pagination-gallery cursor"
            :class="[nextShow ? '' : 'swiperNoSwiping']"
            slot="pagination"
          ></div>
        </div>
        <div class="btn-video" v-if="btnIdx == 2">
          <img src="../../assets/img/layer4/video_s_bg.png" class="v-info" />
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "app",

  data() {
    return {
      btnIdx: 1,
      btnList: [
        {
          id: 1,
          btn: require("../../assets/img/layer4/2.png"),
          btnActive: require("../../assets/img/layer4/2-active.png")
        },
        {
          id: 2,

          btn: require("../../assets/img/layer4/1.png"),
          btnActive: require("../../assets/img/layer4/1-active.png")
        }
      ],
      galleryList: [
        {
          id: 1,
          url: require("../../assets/img/layer4/2.jpg")
          // list: [
          //   require("../../assets/img/layer4/2.jpg"),
          //   require("../../assets/img/layer4/2.jpg"),
          //   require("../../assets/img/layer4/2.jpg"),
          //   require("../../assets/img/layer4/2.jpg")
          // ]
        },
        {
          id: 2,
          url: require("../../assets/img/layer4/1.jpg")
          // list: [
          //   require("../../assets/img/layer4/1.jpg"),
          //   require("../../assets/img/layer4/1.jpg"),
          //   require("../../assets/img/layer4/1.jpg"),
          //   require("../../assets/img/layer4/1.jpg")
          // ]
        },
        {
          id: 3,
          url: require("../../assets/img/layer4/3.jpg")
          // list: [
          //   require("../../assets/img/layer4/3.jpg"),
          //   require("../../assets/img/layer4/3.jpg"),
          //   require("../../assets/img/layer4/3.jpg"),
          //   require("../../assets/img/layer4/3.jpg")
          // ]
        }
      ],
      nextShow: true,
      galleryOptions: {
        loop: true,
        observer: true, //修改swiper自己或子元素时，自动初始化swiper
        observeParents: true, //修改swiper的父元素时，自动初始化swiper
        allowTouchMove: false,
        pagination: {
          el: ".swiper-pagination-gallery",
          clickable: true,
          bulletClass: "custom-bullet",
          bulletActiveClass: "custom-bullet-active"
        },
        navigation: {
          nextEl: ".swiper-button-next-gallery",
          prevEl: ".swiper-button-prev-gallery"
        }
      }
    };
  },
  methods: {
    handleBtn(val) {
      this.btnIdx = val.id;
    }
  }
};
</script>
<style lang="scss" scoped>
.module-layer4 {
  // pointer-events: none;
  background-image: url("../../assets/img/layer4/bg.png");
  background-position: center;

  background-repeat: no-repeat;
  background-size: cover;
  position: relative;
  .screen-container {
    width: 100%;
    position: relative;
    .cha-r-b {
      position: absolute;
      bottom: -10%;
      right: 3vw;
      height: 732px;
      width: auto;
    }
    .kv-content {
      position: absolute;
      left: 50%;
      top: 1vw;
      transform: translate(-50%, 0);
      width: 800px;
      display: flex;
      align-items: center;
      flex-direction: column;
      justify-content: center;
      .title {
        width: auto;
        height: 218px;
      }
      .btn-list {
        display: flex;
        align-items: center;
        gap: 1vw;
        margin-bottom: 1vw;
        .btn-size {
          width: auto;
          height: 56px;
        }
      }
      .btn-video {
        background-image: url("../../assets/img/layer4/video_ssum.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 798px;
        height: 460px;
        display: flex;
        align-items: center;
        justify-content: center;
        img {
            width: 660px;
            height: auto;
        
        }
      }
      .btn-gallery {
        background-image: url("../../assets/img/layer4/gallery_ssum.png");
        background-position: center;
        background-repeat: no-repeat;
        background-size: 100% 100%;
        width: 738px;
        height: 490px;
        position: relative;

        .g-banner {
          display: flex;
          align-items: center;
          justify-content: center;
          flex-wrap: wrap;
          gap: 2vw;
          margin-top: 1.6vw;
          .g-item-bg-i {
            width: 660px;
            height: 380px;
            background-color: #ffffff;
            border-radius: 17px;
            border: solid 2px rgba(103, 163, 255, 0.26);
            display: flex;
            align-items: center;
            justify-content: center;
            .d-info {
              // width: 570px;
              height: auto;
              width: 98%;
              border-radius: 4px;
            }
          }

          // .g-item-bg {
          //   width: 321px;
          //   height: 190px;
          //   background-color: #ffffff;
          //   border-radius: 17px;
          //   border: solid 2px rgba(103, 163, 255, 0.26);
          //   display: flex;
          //   align-items: center;
          //   justify-content: center;
          //   .info {
          //     width: 304px;
          //     height: auto;
          //   }
          // }
        }
      }

      // 菜单
      .swiper-slide {
        overflow: hidden;
      }
      .swiper-button-prev-gallery:after {
        display: none;
      }

      .swiper-button-next-gallery:after {
        display: none;
      }

      .swiper-button-prev-gallery {
        background: url("../../assets/img/layer4/prev.png") no-repeat top;
        background-size: 100% 100%;
        width: 49px;
        height: 53px;
        top: 12vw;
        left: -3vw;
        position: absolute;
      }

      .swiper-button-next-gallery {
        background: url("../../assets/img/layer4/next.png") no-repeat top;
        background-size: 100% 100%;
        width: 49px;
        height: 53px;
        top: 12vw;
        right: -3vw;
        position: absolute;
      }

      /deep/ .swiper-pagination-gallery {
        position: absolute;
        bottom: 1vw;
        display: flex;
        justify-content: center;
        align-items: center;
        gap: 1vw;
        left: 50%;
        transform: translateX(-50%);
        cursor: pointer;
        .custom-bullet {
          display: inline-block;
          width: 23px;
          height: 21px;
          background: url("../../assets/img/layer4/media.png");
          background-size: 100% 100%;
        }

        .custom-bullet-active {
          width: 23px;
          height: 21px;
          background: url("../../assets/img/layer4/media-active.png") no-repeat
            top;
          background-size: 100% 100%;
        }
      }
    }
  }
}
@media screen and (max-width: 1200px) {
  .module-layer4 {
    .kv-content {
      top: 5vw !important;
    }
  }
}
@media screen and (min-width: 2000px) and (max-width: 2561px) {
  .module-layer4 {
    .kv-content {
      top: 5vw !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/publicComponents/layer4.vue